/*
angelCake v3.0 (http://angelcake.executiveresults.ca)
Copyright 2018 Executive Results
Licensed under the MIT license
*/

//var angelCake = {}; -- already set in app-config.js

// @codekit-append "_cookies.js"
// @codekit-append "vuejs/_vue.js"
// @codekit-append "vuejs/components/_select2Component.js"
// @codekit-append "vuejs/components/_datepickerComponent.js"
// DISABLED codekit-append "_jquery-3.2.1.min.js"
// @codekit-append "_jstz.js"
// @codekit-append "_lodash-4.17.4.js"
// @codekit-append "_debounce.js"
// @codekit-append "_loadJS.js"


// @codekit-append "_multi.js"
// @codekit-append "_selects.js"
// @codekit-append "_select2.js"

// @codekit-append "_flatpickr.js"
// @codekit-append "_dateTimePicker"

// @codekit-append "_formHelpers"

// DISABLED codekit-append "_ckEditorConfig"

// @codekit-append "_alerts"
// @codekit-append "_modals"
// @codekit-append "_urlvars"
// @codekit-append "_viewportguide"




// @codekit-append "chartjs/_charts-generator.js"
// @codekit-append "tooltipster/_tooltipster-4.2.5.bundle.min.js"
// @codekit-append "tooltipster/_tooltipster-scrollableTip.min.js"
// @codekit-append "_tooltipster-init.js"


// @codekit-append  "_SmartDesk-generateTable.js"



 head.ready("appJS",function(){
  $(document).ready(function(){










    $("sd-menu-toggle").on("click",function(){
      $("sd-menu, sd-menu-content-mask").addClass("shown");
    });
    $("sd-menu-content-mask").on("click",function(){
      $("sd-menu, sd-menu-content-mask").removeClass("shown");
    });
  });
});





